import { TreeSelectProps } from 'antd'

import { useClassifierServiceGetCuatmClassifierElementEndpoint } from 'src/api/queries'
import { CUATMTreeSelect } from 'src/components'
import { useLocales } from 'src/locales'

type Props = Omit<TreeSelectProps, 'value' | 'onChange'> & {
  value?: string | null
  onChange?: (value?: string | null) => void
}

/**
 * A CUATM locality (9). Stores only the locality id; the label of a saved id is loaded by id,
 * since the tree loads its levels lazily.
 */
export const HivCuatmSelect = ({ value, onChange, ...props }: Props) => {
  const { currentLang } = useLocales()

  const { data: locality } =
    useClassifierServiceGetCuatmClassifierElementEndpoint(
      { elementId: String(value) },
      [value],
      { enabled: !!value, retry: false, staleTime: 1000 * 60 * 5 }
    )

  const label = locality?.translation?.[currentLang.value] ?? value

  return (
    <CUATMTreeSelect
      labelInValue
      value={value ? { value, label } : undefined}
      onChange={(selected?: { value?: string } | null) =>
        onChange?.(selected?.value ?? null)
      }
      {...props}
    />
  )
}
